module.exports = __webpack_public_path__ + "static/squid-ball-9d6aaf3102d074dd03a9b74c06d2e880.jpg";